import React, { useEffect, useState } from 'react'
import { Container, Separator } from '../../common/formParts/FieldPartsStyled'
import DeliveryDestinationOptions from './DeliveryDestinationOptions'
import SVG from 'react-inlinesvg';
import Add from '../../common/formParts/icons/Add.svg'
import Eye from '../../common/formParts/icons/Eye.svg'
import Info from '../../common/formParts/icons/Info.svg'
import ConfirmModal from "./ConfirmModal";
import SubmitAbility from "./SubmitAbility";

const DeliveryDestinationFieldForm = (props) => {
  const [destinations, setDestinations] = useState(props.delivery_destinations)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [renderModal, setRenderModal] = useState(0)

  const addDestination = () => {
    // get max destination number from destinations
    const maxDestinationNumber = Math.max.apply(Math, destinations.map((dest) => dest.number))
    const newDestination = { name: "app", number: maxDestinationNumber + 1, id: maxDestinationNumber + 1 }
    setDestinations([...destinations, newDestination])
  }

  const removeDestination = (destination_number) => {
    const destinationsFiltered = destinations.map((dest) => {
      if (dest.number === destination_number) {
        return { ...dest, isDeleted: true }
      } else {
        return dest
      }
    }
    )
    setDestinations(destinationsFiltered)
  }

  const updateDestinations = (newDestinations) => {
    setDestinations(newDestinations)
  }

  const displaySelection = () => {
    setIsModalVisible(true)
    setRenderModal(renderModal + 1)
  }

  useEffect(() => {
    const submitButton = document.getElementById('news-submit-button')
    const submitAbility = SubmitAbility()
    if (submitAbility === false) {
      submitButton.disabled = true
    }
  }, [destinations])

  return (
    <Container>
      {destinations.map((delivery_destination, index) => {
        return delivery_destination.isDeleted !== true &&
          (
            <DeliveryDestinationOptions
              {...props}
              key={index}
              destinationNumber={index}
              delivery_destination={delivery_destination}
              isLastDestination={index === destinations.length - 1}
              handleRemove={(nber) => removeDestination(nber)}
              destinations={destinations}
              handleUpdateDestinations={(dest) => updateDestinations(dest)}
            />
          )
      })}
      <div className="field-unit">
        <div className="field-unit__label">
        </div>
        <div className="field-unit__field">
          <a className="add_destination" href="#" onClick={(e) => { e.preventDefault(); addDestination() }}>
            <SVG src={Add} className="icon" />
            別の配信先を追加する
          </a>
          <div className="add_destination-notification">
            <SVG src={Info} className="icon" />
            <p>複数の配信先を設定し、会員住戸に重複がある場合、詳細な条件の配信先が優先され、それ以外は破棄されます。</p>
          </div>
        </div>
      </div>

      <div className="field-unit">
        <div className="field-unit__label">
        </div>
        <div className="field-unit__field">
          <Separator className="display-selection-separator"></Separator>
          <a href="#" className="display-selection" onClick={(e) => { e.preventDefault(); displaySelection() }}>
            <SVG src={Eye} className="icon" />
            選択した全ての配信先を確認する
          </a>
        </div>
      </div>
      <ConfirmModal key={renderModal} isVisible={isModalVisible} />
    </Container>
  )
}

export default DeliveryDestinationFieldForm
